import { Grid } from '@mui/material';
import { ComputeWalletCard } from 'components/TeamOverview/components/ComputeWalletCard/ComputeWalletCard';
import { AiComputeTransactionsCard } from 'components/TeamOverview/components/AiComputeTransactionsCard/AiComputeTransactionsCard';
import { useFixInternalSidebarDuringScroll } from 'components/TeamOverview/hooks';

export const ComputeSection = ({ team }) => {
  const { containerRef, sidebarRef, sidebarPlaceholderRef } =
    useFixInternalSidebarDuringScroll();

  return (
    <Grid ref={containerRef} item container spacing={2}>
      <Grid item xs={9}>
        <AiComputeTransactionsCard team={team} />
      </Grid>
      <Grid item xs={3} ref={sidebarRef}>
        <ComputeWalletCard team={team} />
      </Grid>
      <Grid item xs={3} ref={sidebarPlaceholderRef} />
    </Grid>
  );
};
